import { useQuery } from '@tanstack/react-query';
import { requestVideoKeys } from '../api/keys';
import { fetchVideoUnitById } from '../api/requestVideoApi';
import { STALE_TIME } from '../utils/constants';
import { toVideoUnit } from '../utils/unit';

const toUnitOrNull = (item) => {
  if (!item) return null;
  return toVideoUnit(item);
};

// Resolves the unit (label and time zone) of a camera id handed in through props.
export const useInitialUnit = (cameraDeviceId) => {
  const query = useQuery({
    queryKey: requestVideoKeys.unitById(cameraDeviceId),
    queryFn: () => fetchVideoUnitById(cameraDeviceId),
    enabled: Boolean(cameraDeviceId),
    staleTime: STALE_TIME.units,
    select: toUnitOrNull,
  });

  return {
    unit: query.data || null,
    isLoading: Boolean(cameraDeviceId) && query.isLoading,
    notFound: query.isSuccess && !query.data,
    isError: query.isError,
    refetch: query.refetch,
  };
};
